import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";
import { CameraOff } from "lucide-react";

export default function BarcodeScanner({ onScan }) {
  const scannerRef = useRef(null);
  const lastRef = useRef({ code: null, ts: 0 });
  const onScanRef = useRef(onScan);
  const [err, setErr] = useState("");

  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);

  useEffect(() => {
    let cancelled = false;

    const handleDecoded = (decodedText) => {
      const now = Date.now();
      if (lastRef.current.code === decodedText && now - lastRef.current.ts < 2500) return;
      lastRef.current = { code: decodedText, ts: now };
      if (onScanRef.current) onScanRef.current(decodedText);
    };

    // pequeno atraso evita a corrida do StrictMode (setup→cleanup→setup) que abria 2 câmeras
    const timer = setTimeout(() => {
      if (cancelled) return;
      const el = document.getElementById("bc-reader");
      if (el) el.innerHTML = ""; // limpa qualquer vídeo remanescente
      const scanner = new Html5Qrcode("bc-reader", { verbose: false });
      scannerRef.current = scanner;
      scanner
        .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 260, height: 160 } }, handleDecoded, () => {})
        .catch(() => {
          if (cancelled) return;
          scanner
            .start({ facingMode: "user" }, { fps: 10, qrbox: { width: 260, height: 160 } }, handleDecoded, () => {})
            .catch(
              () =>
                !cancelled &&
                setErr(
                  "Não foi possível acessar a câmera. Toque em 'aA' na barra do Safari → Configurações do site → permita a Câmera, e recarregue."
                )
            );
        });
    }, 60);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      const s = scannerRef.current;
      scannerRef.current = null;
      if (!s) return;
      const state = s.getState ? s.getState() : null;
      if (state === Html5QrcodeScannerState.SCANNING || state === Html5QrcodeScannerState.PAUSED) {
        s.stop()
          .then(() => s.clear())
          .catch(() => {});
      } else {
        try {
          s.clear();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div className="w-full">
      <div
        id="bc-reader"
        data-testid="barcode-scanner"
        className="w-full overflow-hidden rounded-md border-2 border-slate-300 bg-black"
      />
      {err && (
        <div className="mt-3 flex items-start gap-2 rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="scanner-error">
          <CameraOff size={18} className="mt-0.5 shrink-0" /> <span>{err}</span>
        </div>
      )}
    </div>
  );
}
